import { IR23Report } from '@/interfaces/report';

export const exampleAsphaltDesignR23Report = <IR23Report>{
  projectName: 'Placeholder Report',
  growthRate: 4,
  elasticModulus: 4000001,
  poissonsRatio: 0.3,
  drainageFactor: 1.2,
  initialServiceability: 4.5,
  terminalServiceability: 2,
  deltaServiceability: 2.5,
  ruptureModulus: 800,
  jointSpacing: 170,
  loadTransferCoefficient: 3,
  edgeSupport: 1.01,
  baseThickness: 6.5,
  subgradeReactionModulus: 250,
  minimumThickness: 0,
  reliabilityLevel: 75,
  flexible: {
    layers: [
      {
        coefficient: 0.14,
        drainage: 1,
        thickness: 8,
        type: 'Aggregate Base',
      },
      {
        coefficient: 0.23,
        drainage: 1,
        thickness: 3,
        type: 'Lime treated base',
      },
    ],
    surface_layers: [
      {
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Surface',
        thickness: 5,
      },
      {
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Binder\/Intermediate',
        thickness: 3,
      },
      {
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Base',
        thickness: '?',
      },
    ],
    multiple_lifts: true,
  },
  esalEntry: 'aadt',
  scenarios: [
    {
      scenariotype: 'Analyze Pavement Structure',
      name: 'Analysis',
      layers: [
        {
          type: 'Asphalt - Dense Graded',
          thickness: 9,
          class: 'asphalt',
          poissons: 0.35,
          modulus: 500000,
        },
        {
          type: 'Aggregate Base',
          thickness: 8,
          class: 'asphalt',
          poissons: 0.4,
          modulus: 28000,
        },
      ],
      totalThickness: 17,
      submodulus: 10000,
      subpoissons: 0.45,
      loadConfig: [
        {
          location: {
            x: 0,
            y: 0,
          },
          load: 5000,
          pressure: 140,
        },
        {
          location: {
            x: 8,
            y: 0,
          },
          load: 5000,
          pressure: 140,
        },
        {
          location: {
            x: 84,
            y: 0,
          },
          load: 5000,
          pressure: 140,
        },
        {
          location: {
            x: 92,
            y: 0,
          },
          load: 5000,
          pressure: 140,
        },
        {
          location: {
            x: 4,
            y: 300,
          },
          load: 8000,
          pressure: 140,
        },
        {
          location: {
            x: 88,
            y: 300,
          },
          load: 8000,
          pressure: 140,
        },
      ],
      presetConfig: '3S2',
      pavementLoadResponses: [],
      analyzeDepthResponses: [
        {
          layer: 'Asphalt - Dense Graded',
          depth: 0,
          strain: [
            {
              key: 'vertical',
              value: true,
            },
            {
              key: 'horizontal',
              value: true,
            },
            {
              key: 'deflection',
              value: true,
            },
          ],
          isDefaultDepth: true,
          layernumber: 1,
        },
        {
          layer: 'Asphalt - Dense Graded',
          depth: 9,
          strain: [
            {
              key: 'vertical',
              value: true,
            },
            {
              key: 'horizontal',
              value: true,
            },
            {
              key: 'deflection',
              value: true,
            },
          ],
          isDefaultDepth: true,
          layernumber: 1,
        },
        {
          layer: 'Subgrade',
          depth: 17,
          strain: [
            {
              key: 'vertical',
              value: true,
            },
            {
              key: 'horizontal',
              value: true,
            },
            {
              key: 'deflection',
              value: false,
            },
          ],
          isDefaultDepth: true,
          layernumber: 3,
        },
      ],
      fatigue: {
        selectedModule: 'Minnesota DOT',
        fa: 2.83,
        fb: 3.206,
      },
      rutting: {
        selectedModule: 'AI',
        ra: 1077000000000000000,
        rb: 4.4843,
      },
    },
    {
      scenariotype: 'Calculate Life-Cycle Cost',
      name: 'Full Width PCC vs AC Pavement',
    },
    {
      scenariotype: 'Estimate Material Cost',
      name: 'Costs',
      layers: [
        {
          type: 'Asphalt - Dense Graded',
          thickness: 5,
          class: 'base',
          cost: {
            value: 70,
            metric: 'ton',
          },
          density: 155,
        },
        {
          type: 'Asphalt - Dense Graded',
          thickness: 4,
          class: 'base',
          cost: {
            value: 75,
            metric: 'ton',
          },
          density: 155,
        },
        {
          type: 'Aggregate Base',
          thickness: 8,
          class: 'base',
          cost: {
            value: 30,
            metric: 'ton',
          },
          density: 130,
        },
      ],
      totalThickness: '17.00',
      area: {
        calculatedBy: 'WxL',
        length: {
          value: 4,
          metric: 'miles',
        },
        width: {
          value: 15,
          metric: 'ft',
        },
        calcarea: '35200.00',
      },
    },
  ],
  existingDistress: {
    cracking_data: {
      fatigue: {
        low: 0,
        medium: '<10',
        high: 0,
      },
      transverse: {
        low: 0,
        medium: '<5',
        high: 0,
      },
    },
  },
  existingLayers: [
    {
      type: 'Asphalt - Dense Graded',
      thickness: '4',
      coefficient: 0.25,
      drainage: 1,
      id: 0,
      sn: 1,
      suggestion: '0.20 to 0.30',
    },
    {
      type: 'Aggregate Base',
      thickness: '8',
      coefficient: 0.1,
      drainage: 1,
      id: 1,
      sn: 0.8,
      suggestion: '0.00 to 0.1',
    },
  ],
  existingLayerCoeff: 0.44,
  removeDamaged: 'Yes',
  traffic_data: {
    aadt: 10000,
    traffic_count_year: 2018,
    traffic_growth_rate: 1,
    initial_year_traffic: 3650000,
    lane_type: 'One-Way',
    lane_count: '1',
    lanes_measured_value: 1,
    lanes_counted_value: 1,
  },
  lef_data: {
    passenger_count: 90,
    truck_count: 5,
    single_trailer_count: 2,
    double_trailer_count: 3,
    other_count: 0,
    passenger_multiplier: 0.0001,
    truck_multiplier: 0.6,
    single_trailer_multiplier: 1.5,
    double_trailer_multiplier: 2.63,
    other_multiplier: 0,
    total_count: 100,
    load_equivalency_factor: '0.1390',
  },
  mechanistic: {},
  alternatives: [
    {
      name: 'Alt 1: SMA 30 days',
      activities: [
        {
          name: 'Reconstruction',
          desc: 'Initial Activity',
          startYear: 0,
          serviceLife: 20,
          structuralLife: 50,
          agencyConstructionCost: 2079,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 1066.58,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 35,
          workzoneDuration: 30,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 0,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 858.44334772044,
                trucks: 227.36725310953,
                comboTrucks: 37.913356618241,
                total: 1123.7239574482,
              },
              vehicle: {
                cars: 655.73059728,
                trucks: 164.3942016,
                comboTrucks: 65.92465536,
                total: 886.04945424,
              },
            },
            vehicleCostsPerDay: 3853.6587485214,
            delayCostsPerDay: 59660.843929084,
            queuePeriods: [
              {
                totalCount: 1000,
                count: 1321.55,
                groups: 8,
                queueLength: 0,
                queueSpeed: 2.4405931611777,
                upstreamSpeed: 200,
                avgQueuedVehicles: 165.19375,
                avgQueueLength: 0,
                avgQueueSpeed: 0.30507414514721,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 39481.95,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 4386.8833333333,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26626.30317071,
                  trucks: 5726.3428656197,
                  comboTrucks: 574.48394771526,
                  total: 32927.129984045,
                },
              },
              {
                totalCount: 3500,
                count: 67860.1,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 9694.3,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20709.346910552,
                  trucks: 4453.8222288153,
                  comboTrucks: 446.82084822298,
                  total: 25609.989987591,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51458.252199824,
              trucks: 10896.187283128,
              comboTrucks: 1160.0631946531,
              total: 63514.502677605,
            },
            totalCosts: {
              cars: 1543747.5659947,
              trucks: 326885.61849383,
              comboTrucks: 34801.895839594,
              total: 1905435.0803282,
            },
            vehicleCostsTotal: 115609.76245564,
            delayCostsTotal: 1789825.3178725,
            discountedCosts: {
              cars: 1543747.5659947,
              trucks: 326885.61849383,
              comboTrucks: 34801.895839594,
              total: 1905435.0803282,
            },
          },
        },
        {
          name: 'Mill & Fill #1',
          desc: '2 in (Surface Repair)',
          startYear: 20,
          serviceLife: 20,
          structuralLife: 0,
          agencyConstructionCost: 650,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 74.35,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 25,
          workzoneDuration: 2,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 1,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1091.825295741,
                trucks: 292.6879026032,
                comboTrucks: 49.852811587154,
                total: 1434.3660099313,
              },
              vehicle: {
                cars: 849.01303117653,
                trucks: 212.85085671954,
                comboTrucks: 85.356534693716,
                total: 1147.2204225898,
              },
            },
            vehicleCostsPerDay: 4114.8297168712,
            delayCostsPerDay: 59091.735150524,
            queuePeriods: [
              {
                totalCount: 1000,
                count: 2005.8475396813,
                groups: 8,
                queueLength: 0,
                queueSpeed: 2.4405931611777,
                upstreamSpeed: 200,
                avgQueuedVehicles: 250.73094246017,
                avgQueueLength: 0,
                avgQueueSpeed: 0.30507414514721,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 59741.304432384,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 6637.9227147093,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26155.527176595,
                  trucks: 5693.3161155953,
                  comboTrucks: 583.42684939269,
                  total: 32432.270141583,
                },
              },
              {
                totalCount: 3500,
                count: 102821.48339099,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 14688.78334157,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20343.187804019,
                  trucks: 4428.1347565742,
                  comboTrucks: 453.77643841654,
                  total: 25225.098999009,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51047.981481093,
              trucks: 10951.250365476,
              comboTrucks: 1207.3330208268,
              total: 63206.564867395,
            },
            totalCosts: {
              cars: 102095.96296219,
              trucks: 21902.500730951,
              comboTrucks: 2414.6660416535,
              total: 126413.12973479,
            },
            vehicleCostsTotal: 8229.6594337424,
            delayCostsTotal: 118183.47030105,
            discountedCosts: {
              cars: 102095.96296219,
              trucks: 21902.500730951,
              comboTrucks: 2414.6660416535,
              total: 126413.12973479,
            },
          },
        },
        {
          name: 'Mill & Fill #1 copy',
          desc: '2 in (Surface Repair)',
          startYear: 40,
          serviceLife: 20,
          structuralLife: 0,
          agencyConstructionCost: 650,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 74.35,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 25,
          workzoneDuration: 2,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 2,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1446.3965417776,
                trucks: 394.95131204893,
                comboTrucks: 63.535203812218,
                total: 1904.8830576387,
              },
              vehicle: {
                cars: 1119.0633090936,
                trucks: 280.55350779939,
                comboTrucks: 112.50636051457,
                total: 1512.1231774075,
              },
            },
            vehicleCostsPerDay: 4479.732471689,
            delayCostsPerDay: 60003.912587507,
            queuePeriods: [
              {
                totalCount: 1500,
                count: 3073.9131089767,
                groups: 8,
                queueLength: 0,
                queueSpeed: 3.6608897417665,
                upstreamSpeed: 200,
                avgQueuedVehicles: 384.23913862209,
                avgQueueLength: 0,
                avgQueueSpeed: 0.45761121772081,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 86627.718872273,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 9625.3020969193,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26287.991162742,
                  trucks: 5828.5937472073,
                  comboTrucks: 564.11920060117,
                  total: 32680.704110551,
                },
              },
              {
                totalCount: 3500,
                count: 148597.82858253,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 21228.261226076,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20446.2153488,
                  trucks: 4533.3506922723,
                  comboTrucks: 438.75937824535,
                  total: 25418.325419317,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51908.094535975,
              trucks: 11361.709993311,
              comboTrucks: 1213.84052991,
              total: 64483.645059196,
            },
            totalCosts: {
              cars: 103816.18907195,
              trucks: 22723.419986622,
              comboTrucks: 2427.6810598199,
              total: 128967.29011839,
            },
            vehicleCostsTotal: 8959.4649433779,
            delayCostsTotal: 120007.82517501,
            discountedCosts: {
              cars: 103816.18907195,
              trucks: 22723.419986622,
              comboTrucks: 2427.6810598199,
              total: 128967.29011839,
            },
          },
        },
        {
          name: 'Minor 1',
          desc: 'No',
          startYear: 5,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 3,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 983.25696407801,
                trucks: 270.03680863887,
                comboTrucks: 43.002646546988,
                total: 1296.2964192639,
              },
              vehicle: {
                cars: 740.97009650307,
                trucks: 185.76407434604,
                comboTrucks: 74.494309776996,
                total: 1001.2284806261,
              },
            },
            vehicleCostsPerDay: 1001.2284806261,
            delayCostsPerDay: 1296.2964192639,
            queuePeriods: [
              {
                totalCount: 0,
                count: 227445.21014114,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 9476.8837558808,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1724.2270605811,
              trucks: 455.80088298491,
              comboTrucks: 117.49695632398,
              total: 2297.52489989,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 2',
          desc: 'No',
          startYear: 11,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 4,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1004.3112275743,
                trucks: 289.68172372703,
                comboTrucks: 47.596618077689,
                total: 1341.5895693791,
              },
              vehicle: {
                cars: 800.67700054797,
                trucks: 200.73282654578,
                comboTrucks: 80.497014375653,
                total: 1081.9068414694,
              },
            },
            vehicleCostsPerDay: 1081.9068414694,
            delayCostsPerDay: 1341.5895693791,
            queuePeriods: [
              {
                totalCount: 0,
                count: 245772.60203112,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 10240.52508463,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1804.9882281223,
              trucks: 490.41455027281,
              comboTrucks: 128.09363245334,
              total: 2423.4964108485,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 2',
          desc: 'No',
          startYear: 15,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 5,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1079.4311150363,
                trucks: 304.92278339616,
                comboTrucks: 48.85622243544,
                total: 1433.2101208679,
              },
              vehicle: {
                cars: 843.13115027264,
                trucks: 211.37624638549,
                comboTrucks: 84.765192802601,
                total: 1139.2725894607,
              },
            },
            vehicleCostsPerDay: 1139.2725894607,
            delayCostsPerDay: 1433.2101208679,
            queuePeriods: [
              {
                totalCount: 0,
                count: 258804.15762434,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 10783.506567681,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1922.562265309,
              trucks: 516.29902978165,
              comboTrucks: 133.62141523804,
              total: 2572.4827103287,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 4',
          desc: 'No',
          startYear: 25,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 6,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1235.7764666721,
                trucks: 344.22875332837,
                comboTrucks: 56.697435192908,
                total: 1636.7026551934,
              },
              vehicle: {
                cars: 959.37763199208,
                trucks: 240.51968979098,
                comboTrucks: 96.452171076843,
                total: 1296.3494928599,
              },
            },
            vehicleCostsPerDay: 1296.3494928599,
            delayCostsPerDay: 1636.7026551934,
            queuePeriods: [
              {
                totalCount: 0,
                count: 294486.71160003,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 12270.279650001,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2195.1540986642,
              trucks: 584.74844311934,
              comboTrucks: 153.14960626975,
              total: 2933.0521480532,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 5',
          desc: 'No',
          startYear: 30,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 7,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1351.0823371247,
                trucks: 371.64415032869,
                comboTrucks: 59.075664104316,
                total: 1781.8021515577,
              },
              vehicle: {
                cars: 1023.3797411563,
                trucks: 256.56526655744,
                comboTrucks: 102.88669922982,
                total: 1382.8317069436,
              },
            },
            vehicleCostsPerDay: 1382.8317069436,
            delayCostsPerDay: 1781.8021515577,
            queuePeriods: [
              {
                totalCount: 0,
                count: 314132.54243321,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 13088.855934717,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2374.4620782811,
              trucks: 628.20941688613,
              comboTrucks: 161.96236333414,
              total: 3164.6338585013,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 6',
          desc: 'No',
          startYear: 35,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 8,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1408.0408344929,
                trucks: 395.52076795943,
                comboTrucks: 63.7484162241,
                total: 1867.3100186765,
              },
              vehicle: {
                cars: 1091.6515662707,
                trucks: 273.68127765712,
                comboTrucks: 109.75048835318,
                total: 1475.083332281,
              },
            },
            vehicleCostsPerDay: 1475.083332281,
            delayCostsPerDay: 1867.3100186765,
            queuePeriods: [
              {
                totalCount: 0,
                count: 335088.98815637,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 13962.041173182,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2499.6924007636,
              trucks: 669.20204561655,
              comboTrucks: 173.49890457728,
              total: 3342.3933509575,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 7',
          desc: 'No',
          startYear: 45,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 9,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1639.0385786022,
                trucks: 445.22895383258,
                comboTrucks: 71.01038243454,
                total: 2155.2779148693,
              },
              vehicle: {
                cars: 1242.1627338411,
                trucks: 311.41501057618,
                comboTrucks: 124.88230756531,
                total: 1678.4600519825,
              },
            },
            vehicleCostsPerDay: 1678.4600519825,
            delayCostsPerDay: 2155.2779148693,
            queuePeriods: [
              {
                totalCount: 0,
                count: 381289.29272762,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 15887.053863651,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2881.2013124432,
              trucks: 756.64396440876,
              comboTrucks: 195.89268999985,
              total: 3833.7379668518,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
      ],
      index: 0,
    },
    {
      name: 'Alt 4: SMA 30 days',
      activities: [
        {
          name: 'Reconstruction',
          desc: 'Initial Activity',
          startYear: 0,
          serviceLife: 20,
          structuralLife: 50,
          agencyConstructionCost: 2079,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 1066.58,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 25,
          workzoneDuration: 30,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 1,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 858.44334772044,
                trucks: 227.36725310953,
                comboTrucks: 37.913356618241,
                total: 1123.7239574482,
              },
              vehicle: {
                cars: 655.73059728,
                trucks: 164.3942016,
                comboTrucks: 65.92465536,
                total: 886.04945424,
              },
            },
            vehicleCostsPerDay: 3853.6587485214,
            delayCostsPerDay: 59660.843929084,
            queuePeriods: [
              {
                totalCount: 1000,
                count: 1321.55,
                groups: 8,
                queueLength: 0,
                queueSpeed: 2.4405931611777,
                upstreamSpeed: 200,
                avgQueuedVehicles: 165.19375,
                avgQueueLength: 0,
                avgQueueSpeed: 0.30507414514721,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 39481.95,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 4386.8833333333,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26626.30317071,
                  trucks: 5726.3428656197,
                  comboTrucks: 574.48394771526,
                  total: 32927.129984045,
                },
              },
              {
                totalCount: 3500,
                count: 67860.1,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 9694.3,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20709.346910552,
                  trucks: 4453.8222288153,
                  comboTrucks: 446.82084822298,
                  total: 25609.989987591,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51458.252199824,
              trucks: 10896.187283128,
              comboTrucks: 1160.0631946531,
              total: 63514.502677605,
            },
            totalCosts: {
              cars: 1543747.5659947,
              trucks: 326885.61849383,
              comboTrucks: 34801.895839594,
              total: 1905435.0803282,
            },
            vehicleCostsTotal: 115609.76245564,
            delayCostsTotal: 1789825.3178725,
            discountedCosts: {
              cars: 1543747.5659947,
              trucks: 326885.61849383,
              comboTrucks: 34801.895839594,
              total: 1905435.0803282,
            },
          },
        },
        {
          name: 'Mill & Fill #1',
          desc: '2 in (Surface Repair)',
          startYear: 20,
          serviceLife: 20,
          structuralLife: 0,
          agencyConstructionCost: 650,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 74.35,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 25,
          workzoneDuration: 2,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 1,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1091.825295741,
                trucks: 292.6879026032,
                comboTrucks: 49.852811587154,
                total: 1434.3660099313,
              },
              vehicle: {
                cars: 849.01303117653,
                trucks: 212.85085671954,
                comboTrucks: 85.356534693716,
                total: 1147.2204225898,
              },
            },
            vehicleCostsPerDay: 4114.8297168712,
            delayCostsPerDay: 59091.735150524,
            queuePeriods: [
              {
                totalCount: 1000,
                count: 2005.8475396813,
                groups: 8,
                queueLength: 0,
                queueSpeed: 2.4405931611777,
                upstreamSpeed: 200,
                avgQueuedVehicles: 250.73094246017,
                avgQueueLength: 0,
                avgQueueSpeed: 0.30507414514721,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 59741.304432384,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 6637.9227147093,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26155.527176595,
                  trucks: 5693.3161155953,
                  comboTrucks: 583.42684939269,
                  total: 32432.270141583,
                },
              },
              {
                totalCount: 3500,
                count: 102821.48339099,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 14688.78334157,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20343.187804019,
                  trucks: 4428.1347565742,
                  comboTrucks: 453.77643841654,
                  total: 25225.098999009,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51047.981481093,
              trucks: 10951.250365476,
              comboTrucks: 1207.3330208268,
              total: 63206.564867395,
            },
            totalCosts: {
              cars: 102095.96296219,
              trucks: 21902.500730951,
              comboTrucks: 2414.6660416535,
              total: 126413.12973479,
            },
            vehicleCostsTotal: 8229.6594337424,
            delayCostsTotal: 118183.47030105,
            discountedCosts: {
              cars: 102095.96296219,
              trucks: 21902.500730951,
              comboTrucks: 2414.6660416535,
              total: 126413.12973479,
            },
          },
        },
        {
          name: 'Mill & Fill #1 copy',
          desc: '2 in (Surface Repair)',
          startYear: 40,
          serviceLife: 20,
          structuralLife: 0,
          agencyConstructionCost: 650,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 74.35,
          workzoneLength: 0.3,
          workzoneCapacity: 500,
          noLanesWorkzone: 1,
          workzoneSpeedLimit: 25,
          workzoneDuration: 2,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [
            {
              name: 'Line 1',
              units: 'ea',
              price: '1500000',
              quantity: '1',
            },
            {
              name: 'Line 2',
              units: 'ft',
              price: '70',
              quantity: '1000',
            },
            {
              name: 'Line 3',
              units: 'ls',
              price: '9000',
              quantity: '1',
            },
            {
              name: 'Line 4',
              units: 'ton',
              price: '25000',
              quantity: '20',
            },
          ],
          noUserCost: false,
          altIndex: 0,
          index: 2,
          activityResults: {
            queueLengthWarning: true,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1446.3965417776,
                trucks: 394.95131204893,
                comboTrucks: 63.535203812218,
                total: 1904.8830576387,
              },
              vehicle: {
                cars: 1119.0633090936,
                trucks: 280.55350779939,
                comboTrucks: 112.50636051457,
                total: 1512.1231774075,
              },
            },
            vehicleCostsPerDay: 4479.732471689,
            delayCostsPerDay: 60003.912587507,
            queuePeriods: [
              {
                totalCount: 1500,
                count: 3073.9131089767,
                groups: 8,
                queueLength: 0,
                queueSpeed: 3.6608897417665,
                upstreamSpeed: 200,
                avgQueuedVehicles: 384.23913862209,
                avgQueueLength: 0,
                avgQueueSpeed: 0.45761121772081,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0,
                delays: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleVocCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
                idleDelayCost: {
                  cars: 0,
                  trucks: 0,
                  comboTrucks: 0,
                  total: 0,
                },
              },
              {
                totalCount: 4500,
                count: 86627.718872273,
                groups: 9,
                queueLength: 4.5,
                queueSpeed: 10.9826692253,
                upstreamSpeed: 225,
                avgQueuedVehicles: 9625.3020969193,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1560.8945187536,
                  trucks: 175.38140660152,
                  comboTrucks: 17.538140660152,
                  total: 1560.8945187536,
                },
                idleVocCost: {
                  cars: 1467.2408476284,
                  trucks: 182.39666286559,
                  comboTrucks: 19.642717539371,
                  total: 1669.2802280333,
                },
                idleDelayCost: {
                  cars: 26287.991162742,
                  trucks: 5828.5937472073,
                  comboTrucks: 564.11920060117,
                  total: 32680.704110551,
                },
              },
              {
                totalCount: 3500,
                count: 148597.82858253,
                groups: 7,
                queueLength: 3.5,
                queueSpeed: 8.5420760641219,
                upstreamSpeed: 175,
                avgQueuedVehicles: 21228.261226076,
                avgQueueLength: 0.5,
                avgQueueSpeed: 1.2202965805888,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: 0.3897364591145,
                delays: {
                  cars: 1214.0290701417,
                  trucks: 136.40776069007,
                  comboTrucks: 13.640776069007,
                  total: 1214.0290701417,
                },
                idleVocCost: {
                  cars: 1141.1873259332,
                  trucks: 141.86407111768,
                  comboTrucks: 15.277669197288,
                  total: 1298.3290662481,
                },
                idleDelayCost: {
                  cars: 20446.2153488,
                  trucks: 4533.3506922723,
                  comboTrucks: 438.75937824535,
                  total: 25418.325419317,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 51908.094535975,
              trucks: 11361.709993311,
              comboTrucks: 1213.84052991,
              total: 64483.645059196,
            },
            totalCosts: {
              cars: 103816.18907195,
              trucks: 22723.419986622,
              comboTrucks: 2427.6810598199,
              total: 128967.29011839,
            },
            vehicleCostsTotal: 8959.4649433779,
            delayCostsTotal: 120007.82517501,
            discountedCosts: {
              cars: 103816.18907195,
              trucks: 22723.419986622,
              comboTrucks: 2427.6810598199,
              total: 128967.29011839,
            },
          },
        },
        {
          name: 'Minor 1',
          desc: 'No',
          startYear: 5,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 3,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 983.25696407801,
                trucks: 270.03680863887,
                comboTrucks: 43.002646546988,
                total: 1296.2964192639,
              },
              vehicle: {
                cars: 740.97009650307,
                trucks: 185.76407434604,
                comboTrucks: 74.494309776996,
                total: 1001.2284806261,
              },
            },
            vehicleCostsPerDay: 1001.2284806261,
            delayCostsPerDay: 1296.2964192639,
            queuePeriods: [
              {
                totalCount: 0,
                count: 227445.21014114,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 9476.8837558808,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1724.2270605811,
              trucks: 455.80088298491,
              comboTrucks: 117.49695632398,
              total: 2297.52489989,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 2',
          desc: 'No',
          startYear: 11,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 4,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1004.3112275743,
                trucks: 289.68172372703,
                comboTrucks: 47.596618077689,
                total: 1341.5895693791,
              },
              vehicle: {
                cars: 800.67700054797,
                trucks: 200.73282654578,
                comboTrucks: 80.497014375653,
                total: 1081.9068414694,
              },
            },
            vehicleCostsPerDay: 1081.9068414694,
            delayCostsPerDay: 1341.5895693791,
            queuePeriods: [
              {
                totalCount: 0,
                count: 245772.60203112,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 10240.52508463,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1804.9882281223,
              trucks: 490.41455027281,
              comboTrucks: 128.09363245334,
              total: 2423.4964108485,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 2',
          desc: 'No',
          startYear: 15,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 5,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1079.4311150363,
                trucks: 304.92278339616,
                comboTrucks: 48.85622243544,
                total: 1433.2101208679,
              },
              vehicle: {
                cars: 843.13115027264,
                trucks: 211.37624638549,
                comboTrucks: 84.765192802601,
                total: 1139.2725894607,
              },
            },
            vehicleCostsPerDay: 1139.2725894607,
            delayCostsPerDay: 1433.2101208679,
            queuePeriods: [
              {
                totalCount: 0,
                count: 258804.15762434,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 10783.506567681,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 1922.562265309,
              trucks: 516.29902978165,
              comboTrucks: 133.62141523804,
              total: 2572.4827103287,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 4',
          desc: 'No',
          startYear: 25,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 6,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1235.7764666721,
                trucks: 344.22875332837,
                comboTrucks: 56.697435192908,
                total: 1636.7026551934,
              },
              vehicle: {
                cars: 959.37763199208,
                trucks: 240.51968979098,
                comboTrucks: 96.452171076843,
                total: 1296.3494928599,
              },
            },
            vehicleCostsPerDay: 1296.3494928599,
            delayCostsPerDay: 1636.7026551934,
            queuePeriods: [
              {
                totalCount: 0,
                count: 294486.71160003,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 12270.279650001,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2195.1540986642,
              trucks: 584.74844311934,
              comboTrucks: 153.14960626975,
              total: 2933.0521480532,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 5',
          desc: 'No',
          startYear: 30,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 7,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1351.0823371247,
                trucks: 371.64415032869,
                comboTrucks: 59.075664104316,
                total: 1781.8021515577,
              },
              vehicle: {
                cars: 1023.3797411563,
                trucks: 256.56526655744,
                comboTrucks: 102.88669922982,
                total: 1382.8317069436,
              },
            },
            vehicleCostsPerDay: 1382.8317069436,
            delayCostsPerDay: 1781.8021515577,
            queuePeriods: [
              {
                totalCount: 0,
                count: 314132.54243321,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 13088.855934717,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2374.4620782811,
              trucks: 628.20941688613,
              comboTrucks: 161.96236333414,
              total: 3164.6338585013,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 6',
          desc: 'No',
          startYear: 35,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 8,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1408.0408344929,
                trucks: 395.52076795943,
                comboTrucks: 63.7484162241,
                total: 1867.3100186765,
              },
              vehicle: {
                cars: 1091.6515662707,
                trucks: 273.68127765712,
                comboTrucks: 109.75048835318,
                total: 1475.083332281,
              },
            },
            vehicleCostsPerDay: 1475.083332281,
            delayCostsPerDay: 1867.3100186765,
            queuePeriods: [
              {
                totalCount: 0,
                count: 335088.98815637,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 13962.041173182,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2499.6924007636,
              trucks: 669.20204561655,
              comboTrucks: 173.49890457728,
              total: 3342.3933509575,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
        {
          name: 'Minor 7',
          desc: 'No',
          startYear: 45,
          serviceLife: 0,
          structuralLife: 0,
          agencyConstructionCost: 5,
          agencyMaintenanceCost: null,
          userWorkzoneCost: 0,
          workzoneLength: 0,
          workzoneCapacity: 0,
          noLanesWorkzone: 0,
          workzoneSpeedLimit: 0,
          workzoneDuration: 0,
          laneClosePeriods: [
            {
              start: 8,
              end: 16,
            },
          ],
          nightShift: false,
          lineItems: [],
          noUserCost: true,
          altIndex: 0,
          index: 9,
          activityResults: {
            queueLengthWarning: false,
            traverseWzCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            weightedSlowCosts: {
              delay: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
              vehicle: {
                cars: 0,
                trucks: 0,
                comboTrucks: 0,
                total: 0,
              },
            },
            weightedStoppedCosts: {
              delay: {
                cars: 1639.0385786022,
                trucks: 445.22895383258,
                comboTrucks: 71.01038243454,
                total: 2155.2779148693,
              },
              vehicle: {
                cars: 1242.1627338411,
                trucks: 311.41501057618,
                comboTrucks: 124.88230756531,
                total: 1678.4600519825,
              },
            },
            vehicleCostsPerDay: 1678.4600519825,
            delayCostsPerDay: 2155.2779148693,
            queuePeriods: [
              {
                totalCount: 0,
                count: 381289.29272762,
                groups: 24,
                queueLength: 0,
                queueSpeed: 0,
                upstreamSpeed: 600,
                avgQueuedVehicles: 15887.053863651,
                avgQueueLength: 0,
                avgQueueSpeed: 0,
                avgUpstreamSpeed: 25,
                avgDelayPerVehicle: null,
                delays: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleVocCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
                idleDelayCost: {
                  cars: null,
                  trucks: null,
                  comboTrucks: null,
                  total: null,
                },
              },
            ],
            totalCostsPerDay: {
              cars: 2881.2013124432,
              trucks: 756.64396440876,
              comboTrucks: 195.89268999985,
              total: 3833.7379668518,
            },
            totalCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
            vehicleCostsTotal: 0,
            delayCostsTotal: 0,
            discountedCosts: {
              cars: 0,
              trucks: 0,
              comboTrucks: 0,
              total: 0,
            },
          },
        },
      ],
      index: 0,
    },
  ],

  freeFlowCalc: {
    unit: 'miles',
    laneWidth: 12,
    percentTruckBus: '',
    gradeLength: '0',
    shoulderWidth: 6,
    percentGrade: '0.00',
    obsTwoSides: false,
  },
  analyzedBy: 'James Feracor',
  userCostsInAnalysis: true,
  userCostComputationMethod: 'Calculated',
  maxQueueLength: '.5',
  passengerCarsTime: '16.83',
  singleUnitTrucksTime: '33.83',
  combinationTrucksTime: '33',
  probabilistic: {
    annualGrowthTraffic: {
      Prob: 'Normal',
      Mean: 1.3,
      Std: 0.05,
      Min: null,
      Max: null,
      Mode: null,
    },
    passengerCarsTime: {
      Prob: 'Normal',
      Mean: 16.83,
      Std: 0.5,
      Min: null,
      Max: null,
      Mode: null,
    },
    singleUnitTrucksTime: {
      Prob: 'Normal',
      Mean: 33.83,
      Std: 0.7,
      Min: null,
      Max: null,
      Mode: null,
    },
    combinationTrucksTime: {
      Prob: 'Normal',
      Mean: 33,
      Std: 0.5,
      Min: null,
      Max: null,
      Mode: null,
    },
  },
  lccaProjectDescription: 'King Street River St. to Bethel St. (Honululu HI)\nNew concrete bus lane + resurface 3 lanes ',
  analysisDirection: 'North',
  lccaStateValue: 'US-HI',
  lccaStateLabel: 'Hawaii',
  subgrade: 10000,
  baseModulus: 15000,
  slabCoefficient: 1.1,
  baseLayerType: 'Aggregate',
  projectExtent_begin: '0',
  projectExtent_end: '0.3',
  comments: 'Validation Check 1 - User Costs Calculated No Salvage Probabilistic',
  analysisPeriod: '50',
  beginningAnalysisPeriod: '2012',
  trafficYear: '2012',
  annualGrowthTraffic: '1.3',
  singleTruckAADT: '10',
  combinationTruckAADT: '1',
  lanesNormalOpt: '4',
  aadtAnalysisPeriod: '20100',
  freeFlowCapacity: '1627',
  speedLimitNormalOpt: '25',
  noShowPercent: '0',
  detourPercent: '0',
  additionalDetourTime: '0',
  trafficHourlyDistribution: [
    0.012,
    0.008,
    0.007,
    0.005,
    0.007,
    0.017,
    0.051,
    0.078,
    0.063,
    0.052,
    0.047,
    0.053,
    0.056,
    0.057,
    0.059,
    0.065,
    0.079,
    0.085,
    0.059,
    0.039,
    0.033,
    0.028,
    0.023,
    0.017,
  ],
  probabilistic_input_mean: '33',
  probabilistic_input_std: '.5',
  maxIterations: 2000,
  probabilistic_input_minimum: '1',
  probabilistic_input_maximum: '1.7',
  probabilistic_input_mode: '1.3',
  determineScenarioName: 'New Scenario',
  determineScenarioDescription: 'Testing',
  stateValue: 'US-WA',
  stateLabel: 'Washington',
  designYear: '2018',
  roadwayClassification: 'Local',
  pavementType: 'AC Overlay on Asphalt',
  standardError: 0.5,
  layerCoefficient: 0.44,
  drainageCoefficient: 1,
  initialTraffic: '3650000',
  loadEquivalencyFactor: '0.1390',
  esals: 507000,
  totalDesignEsals: 13938756.588039,
  overlayApproach: 'Condition Survey',
  designPeriod: 15,
  existingSubgradeType: 'A-2-4',
  existingResilientModulus: '10000',
  fatigueMedium: '<10',
  transverseMedium: '<5',
  coresTaken: 'Yes',
  crackCoresTaken: 'Yes',
  Coefficient0: '0.25',
  Coefficient1: '0.1',
  trafficGrowthRate: '4',
  calculatedDesign: {
    layers: [
      {
        label: 'Overlay',
        depth: '5.0',
        type: 'asphalt',
        showLayer: true,
        height: 58.823529411765,
      },
      {
        label: 'Asphalt - Dense Graded',
        depth: 4,
        type: 'asphalt',
        showLayer: true,
        height: 47.058823529412,
      },
      {
        label: 'Aggregate Base',
        depth: 8,
        type: 'asphalt',
        showLayer: true,
        height: 94.117647058824,
      },
    ],
    layerCalculations: {
      overlay: {
        existingResilientModulus: '10000',
        designSN: '4.00',
        effectiveSN: '1.80',
        removedDepth: '0',
        snRemoved: '1.00',
        existingLayerCoeff: '0.44',
        estimatedStructuralCoefficient: '0.00',
        overlayLayerMinimumThickness: '0.00',
        neededDepth: '4.99',
        overlaySN: '2.20',
        effectiveSNAfter: '1.80',
        asphaltLayerCoefficient: '0.25',
      },
    },
    warning: false,
  },
  presetSelection: '3S2',
  lengthMetricsSelection: 'miles',
  length: '4',
  widthMetricsSelection: 'ft',
  width: '15',
};
